const types = {
  stroke: [
    "home",
    "submenu_line",
    "plus",
    "reset",
    "logout",
    "download",
    "double_check",
    "x",
    "coins",
    "user_settings",
    "duplicate",
    "thief_protection_edit",
    "thief_protection",
    "secure",
    "not_secure",
  ],
  fill: [
    "device_management",
    "import",
    "administration",
    "docs",
    "butler",
    "drag_and_drop",
    "service",
    "notifications",
    "fault",
    "check",
    "users",
    "arrow_down",
    "arrow_up",
    "arrow_right",
    "arrow_left",
    "customer",
    "cog",
    "edit",
    "euro",
    "trash",
    "building",
    "location",
    "load-change",
    "gate-0",
    "gate-25",
    "gate-50",
    "gate-75",
    "gate-100",
    "gate-closed",
    "gate-opening-animation",
    "gate-closing-animation",
    "list",
    "link-chain",
    "light_bulb",
    "history",
    "details",
    "export",
    "all_clear",
    "repair",
    "replace",
    "paperclip",
    "info-circle",
    "eye",
    "send_mail",
    "profile-circle",
  ],
};

const iconTypes: Map<string, string> = new Map<string, string>();
types.stroke.forEach((icon) => {
  iconTypes.set(icon, "stroke");
});
types.fill.forEach((icon) => {
  iconTypes.set(icon, "fill");
});

export const ICON_TYPES: Map<string, string> = iconTypes;
